var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFriends = function SvgFriends(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.361 26.678v13.524c.28 2.497-1.155 3.983-3.201 5.12-1.157.642-3.935 2.137-6.656 2.053-2.097-.067-3.686-.922-5.745-2.054-2.327-1.278-3.7-3.13-3.7-5.119V26.678c0-5.496 5.593-6.011 5.796-6.028h7.817s5.69.43 5.69 6.028Zm-20.25-8.918c1.728 0 1.927.825 3.02 1.968-3.351.888-4.459 3.774-4.459 7.332v13.257c0 2.534 1.539 3.793 3.538 5.214L3.56 42.168C1.465 41.255 0 39.222 0 36.849V23.59c0-3.222 2.689-5.829 6.002-5.829h8.109Zm29.273 0c3.314 0 6.002 2.607 6.002 5.829v13.26c0 2.384-1.474 4.426-3.59 5.331L33.72 45.531s2.764-1.843 2.995-5.213V27.059c0-3.555-1.493-6.437-4.839-7.332 1.094-1.142 1.671-1.967 3.405-1.967h8.103ZM24.694 5.393a6.465 6.465 0 1 1 0 12.931 6.465 6.465 0 1 1 0-12.93Zm14.639-3.472a6.466 6.466 0 1 1-.003 12.932 6.466 6.466 0 0 1 .003-12.932Zm-29.275 0a6.465 6.465 0 1 1-.002 12.93 6.465 6.465 0 0 1 .002-12.93Z",
    fill: "#333",
    fillRule: "evenodd"
  })));
};

export default SvgFriends;